import dhtmlXTreeView from './dhtmlXTreeView';
import './dhtmlXTreeViewExtend';

export default dhtmlXTreeView;



// WEBPACK FOOTER //
// ./goingsrc/dx/dxSource/components/dhtmlXTreeView/index.js